import { createSelector } from 'reselect';
import { gettr } from '../../utils';

export const selectFiltersMetadata = state => ({
    error: state.filters.error,
    isLoading: state.filters.isBranchesLoading || state.filters.isDoctorsLoading,
    doctorsData: state.filters.doctors,
    branchesData: state.filters.doctors,
    doctors: state.filters.doctorsMetadata,
    branches: state.filters.branchesMetadata,
    specializations: state.filters.specializationsMetadata,
    selectedBranch: state.filters.selectedBranch,
    selectedDoctor: state.filters.selectedDoctor,
    selectedSpecialization: state.filters.selectedSpecialization,
    date: state.filters.date,
    fulldoctors: state.filters.doctors,
    forChild: state.filters.forChild,
    childrenAge: state.filters.childrenAge,
});

export const selectFilters = createSelector(gettr('filters', {}), ({
    selectedBranch,
    selectedDoctor,
    selectedSpecialization,
    date,
    isBranchesLoading,
    isDoctorsLoading,
    forChild,
    childrenAge,
    doctors,
}) => ({
    branch: selectedBranch,
    doctor: selectedDoctor,
    specialization: selectedSpecialization,
    date,
    isLoading: isBranchesLoading || isDoctorsLoading,
    forChild,
    childrenAge,
    doctorsData: doctors,
}));
